import { gql } from "lib/apolloClient";
import { userNameFragment } from "modules/CommonFragments";

export const getAccountTemplatesCountQuery = gql`
  query getAccountTemplatesCount($id: ID!) {
    node(id: $id, type: CURRICULUM_PROGRAM) {
      ... on GenericCurriculumProgram {
        id
        transcriptTemplates {
          totalCount
        }
      }
    }
  }
`;

export const getSchoolTranscriptTemplatesQuery = gql`
  query getSchoolTemplates($id: ID!) {
    node(id: $id, type: CURRICULUM_PROGRAM) {
      ... on GenericCurriculumProgram {
        id
        transcriptTemplates {
          edges {
            node {
              id
              name
              body
            }
          }
        }
      }
    }
  }
`;

export const getStudentTranscriptDataQuery = gql`
  query getStudentTranscriptData($id: ID!) {
    node(id: $id, type: STUDENT) {
      ... on Student {
        ...userNameFields
        profileImage
        sourceId
        familyMembers {
          ...userNameFields
        }
        staffRelation(filters: { relation: "HOMEROOM" }) {
          edges {
            node {
              ...userNameFields
            }
          }
        }
        yearGroup {
          id
          name
          curriculumProgram {
            id
            logo
            name: label
            websiteLink
            address {
              id
              line1
              city
              state
              country
              phoneNumber
              email
            }
          }
          grade {
            id
            name
          }
        }
        transcriptSummary {
          id
          configuration
          basicDetails {
            id
            fields {
              id
              fieldUid
              sourceValue
              value
            }
          }
          grades {
            id
            configuration
            grade {
              id
              name
            }
            school {
              id
              name
            }
            academicYear {
              id
              label
              isCustom
            }
            gradingPeriods {
              gradingPeriod {
                id
                name
              }
              isEnabled
            }
            courses {
              course {
                id
                name
              }
              includeInGpa
              level {
                id
                name
              }
              courseCode
            }
            ratingSummary {
              ratings {
                id
                studentGradeMapId
                gradingPeriodId
                courseId
                gradeScaleId
                value
              }
            }
            gpaSettings {
              gpaCalculationMethod
              gpaScoreRoundFormat
              gpaDecimalPrecision
              maxGpaValue
            }
          }
          comments {
            id
            commentField {
              id
              label
              description
            }
            value
          }
        }
      }
    }
  }
  ${userNameFragment}
`;

export const getOrgGradeScalesQuery = gql`
  query getOrgGradeScales($id: ID!) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        id
        transcriptGradeScales(filters: { types: ["CREDIT", "GRADE_POINT"] }) {
          id
          type
        }
      }
    }
  }
`;
